import { getProductVariantImage } from "./productCore";
import { getBrandId, getBrandLogo } from "./brandCore";

export function getOrderId(order) {
    return order?.id;
}

export function getShopOrderCreatedAt(order) {
    return order?.shopOrderCreatedAt;
}

export function getReturnId({ returnObject, orderReturn, orderItem }) {
    return orderItem?.orderReturn?.id || returnObject?.orderReturn?.id || orderReturn?.id || orderReturn?.returnId;
}

export function getReturnStatus({ returnObject, orderReturn }) {
    return orderReturn?.returnStatus || returnObject?.orderReturn?.returnStatus;
}

export function getReturnShipmentCarrier({ orderReturn }) {
    return orderReturn?.shipmentCarrier || orderReturn?.carrier;
}

export function getShipmentSolutionType({ orderReturn }) {
    return orderReturn?.returnShipmentType;
}

// The email a return's label, instructions and status updates go to when an agent sent them
// to someone other than the buyer. Undefined means the buyer.
export function getReturnContactEmail({ orderReturn }) {
    return orderReturn?.contactAddress?.email;
}

// Whether a return is a gift, which decides who gets its store credit and whether the buyer hears
// about it. A return saved before the flag existed counts as a gift when it has a contact.
export function getReturnIsGift({ orderReturn }) {
    return orderReturn?.gift ?? !!getReturnContactEmail({ orderReturn });
}

// The gift checkbox's value on the return forms: ticked once a contact email is entered unless the
// agent unticked it, and never ticked without one, since a gift needs somewhere to send to.
export function resolveGiftChoice({ contactEmail, giftChoice }) {
    if (!contactEmail?.trim()) {
        return false;
    }
    return giftChoice ?? true;
}

export function getOrderItemProduct({ orderItem }) {
    return orderItem?.productVariant?.product;
}

export function getOrderItemProductImage({ orderItem }) {
    return getProductVariantImage(orderItem?.productVariant);
}

export function getOrderItemProductName({ orderItem, productVariant = orderItem?.productVariant }) {
    return productVariant?.product?.title || orderItem?.name;
}

export function getOrderItemProductVariantName({ orderItem, productVariant = orderItem?.productVariant }) {
    return productVariant?.title;
}

export function getOrderItemSku({ orderItem, productVariant = orderItem?.productVariant }) {
    return orderItem?.sku || productVariant?.sku;
}

export function getOrderItemBarCode({ orderItem, productVariant = orderItem?.productVariant }) {
    return orderItem?.barcode || productVariant?.barCode;
}

export function orderReturnHasExchanges(orderReturn) {
    return !!orderReturn?.numberOfExchanges;
}

export function getOrderBrand(order) {
    return order?.merchantBrand;
}

export function getOrderBrandId(order) {
    return getBrandId(getOrderBrand(order));
}

export function getOrderBrandLogo(order) {
    return getBrandLogo(getOrderBrand(order));
}

export function getForeignOrderId(order) {
    return order?.foreignId;
}

export function getForeignOrderNumber(order) {
    return order?.foreignNumber;
}

export function getForeignOrderName(order) {
    return order?.orderForeignName || order?.foreignName;
}

export function getOrderVisualId(order) {
    return getForeignOrderName(order) || getForeignOrderNumber(order) || getForeignOrderId(order) || getOrderId(order);
}

export function getOrderCurrencyCode(order) {
    return order?.currencyCodeCustomer || order?.currencyCode;
}

// Mirrors how TableCellReturnItems derives its count from an order alone, so a row that guards on the
// count and the cell that renders it can't disagree about whether the order has items.
export function getOrderNumberOfItems(order) {
    return order?.totalQuantityBundlesCollapsed || order?.numberOfLineItems;
}
